import ObtainAdvisorError from './ObtainAdvisorError';
class InvestorIsMissingAdvisor extends ObtainAdvisorError {
    constructor() {
        super('Investor does not has advisor assigned');
    }
}
export default InvestorIsMissingAdvisor;
